// @flow

import _ from 'lodash';
import ko from 'rgs-knockout';
import type { Observable } from 'rgs-knockout';
import { observableISODate } from 'observable-iso-date';
import vb from 'validation-builder';
import kv from 'rgs-knockout-validation';
import { JSable } from 'jsable';

// Validation
import { ValidatableMixin } from 'validatable';

import { CERTIFICATE_MAILING_ACTION_TYPES } from '../../constants/certificate-mailing-action-types';

export class CertificateMailingDialogViewModel extends ValidatableMixin(JSable) {

	AccidentContractID: Observable<string>;
	InsurancePeriodStart: observableISODate;
	InsurancePeriodEnd: observableISODate;
	SelectAllInsurers: Observable<boolean>;
	ActionType: Observable<string>;
	TotalCertificatesCount: Observable<number>;

	constructor (options) {
		super();

		this._options = options;

		this.AccidentContractID = ko.observable().extend({
			toFromJS: true,
			validation: vb.all([
				vb.required(true, 'Введите номер договора'),
			]),
		});

		this.InsurancePeriodStart = observableISODate(null)
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.momentIsSameOrBefore(() => this.InsurancePeriodEnd()),
					vb.momentIsSameOrAfter(() => this._options.contractStartDate
						.repr('moment')
						.startOf('day')),
				]),
			});

		this.InsurancePeriodEnd = observableISODate(null)
			.extend({ toFromJS: true })
			.extend({
				validation: vb.all([
					vb.required(true, 'Введите дату окончания'),
				]),
			});

		this.SelectAllInsurers = ko.observable(false).extend({ toFromJS: true });

		this.ActionType = ko.observable(CERTIFICATE_MAILING_ACTION_TYPES.ARCHIVE)
			.extend({ toFromJS: true });

		this.TotalCertificatesCount = ko.observable()
			.extend({ toFromJS: true });
	}

	validationArray () {
		return _.filter(this, kv.utils.isValidatable);
	}
}
